<div id="container">
<div class='box1'>
<!-- ログイン済みの場合（ユーザ名を表示） -->
<div *ngIf="afAuthChild.user | async as user; else showOffer">

    <div *ngIf="strKANO">
        <h1>📑 コンテンツアップロード📑 </h1>
        <p-fileUpload customUpload="true" accept="*" (onSelect)="mySelect($event)">  
        </p-fileUpload>

        カーソル題名　<input type="text" [formControl]="formTitle"><br />
        <textarea cols="50" rows="6" placeholder="カーソルの説明" [formControl]="formDescription"></textarea><br />
        画像URL　<input type="text" [formControl]="formImgURL" id="TEST"><br />
        カーソルURL　<input type="text" [formControl]="formZipURL"><br />
        カーソルURL左利き　<input type="text" [formControl]="formZipURLlefty"><br />
        <p><button (click)="addItem()">投稿する</button></p>

        <hr width="80%" align="left" sizer="2">
    </div>

<!-- ★　メイン：記事一覧を表示する　★ -->
    <div *ngFor="let cursor of (viewCursors | async)">
        <div class="kano-tile">
            <div class="cur-title">{{cursor.title}}</div>
            <img [src]="cursor.imageURL" alt="Cursor's image here" class='curImage'><br />
            <div class="cur-description">{{cursor.description}}</div>
            <a [href]="cursor.downloadURL" (click)="countup(cursor.docid, cursor.count)">
                <img [src]="iconFile" alt="Download">Download (ダウンロード)</a> [{{cursor.count}}]
            <div *ngIf="cursor.downloadURLlefty"><a [href]="cursor.downloadURLlefty">
                <img [src]="iconFile" alt="Download">Lefty (左利き用)</a></div>
        </div>
    </div>
    <div class="kano-tile-end"></div>
    <!-- <button (click)="showNext()">もっと見る<br />See more</button> -->

</div>
<ng-template #showOffer>
    <div class='showOffer'>Not login yet (ログインしていません)</div>
</ng-template>

</div></div>